import {createSlice} from '@reduxjs/toolkit';
import * as reducers from './reducers';
import * as selectors from './selectors';
import {Store} from './types';

const initialState: Store = {
  loaded: false,
  active: false,
  notifications: 0,
  revision: 0,
};

export default createSlice({name: 'app', reducers, initialState});
export {selectors};
